import {api} from '@/shared/services/baseApiClient';
import urljoin from 'url-join';
import WorkspaceViewModel from './models/workspaceViewModel';
import {config} from '@/config/config';
import {UpdateWorkspaceViewModel} from './models/request/updateWorkspaceViewModel';
import {InviteUserViewModel} from '@/workspaces/models/request/inviteUserViewModel';
import {UserViewModel} from '@/workspaces/models/userViewModel';
import {RevokeUserViewModel} from '@/workspaces/models/request/revokeUserViewModel';
import axios, {AxiosPromise} from 'axios';
import {ValidateInviteTokenViewModel} from '@/workspaces/models/response/validateInviteTokenViewModel';
import {RegisterUserViewModel} from '@/workspaces/models/request/registerUserViewModel';

class WorkspacesApi {
	private version = 'v1';

	public loadAll(): Promise<WorkspaceViewModel[]> {
		const url = urljoin(config().workspacesHost, this.version, 'workspaces');
		return api.send('GET', url);
	}

	public getById(id: string): Promise<WorkspaceViewModel> {
		const url = urljoin(config().workspacesHost, this.version, 'workspaces', id);
		return api.send('GET', url);
	}

	public async update(workspaceId: string, request: UpdateWorkspaceViewModel): Promise<WorkspaceViewModel> {
		const url = urljoin(config().workspacesHost, this.version, 'workspaces', workspaceId);
		return await api.send('PUT', url, request);
	}

	public inviteUsers(emails: string[], workspaceId: string) {
		const inviteUserModel: InviteUserViewModel = {
			emails,
			isPlatformAdmin: false,
			workspaceId
		};

		const url = urljoin(config().workspacesHost, this.version, '/users/invite');
		return api.send('POST', url, inviteUserModel);
	}

	public getAllUsersForWorkspace(workspaceId: string): Promise<UserViewModel[]> {
		const url = urljoin(config().workspacesHost, this.version, '/users', `?workspaceid=${workspaceId}`);
		return api.send('GET', url);
	}

	public revokeUser(id: string, workspaceId: string): Promise<void> {

		const removeUserModel: RevokeUserViewModel = {
			userId: id,
			workspaceId,
			isPlatformAdmin: false
		};

		const url = urljoin(config().workspacesHost, this.version, '/users/revoke');
		return api.send('POST', url, removeUserModel);
	}

	public async validateRegistrationToken(token: string): Promise<ValidateInviteTokenViewModel> {
		const url = urljoin(config().workspacesHost, this.version, '/users/invite/status');
		const response = await axios.post(url, token);
		return response.data;
	}

	public registerUser(user: RegisterUserViewModel): AxiosPromise<any> {
		const url = urljoin(config().workspacesHost, this.version, '/users/register');
		return axios.post( url, user);
	}

	public async createUserTokenForConnect(): Promise<string> {
		const url = urljoin(config().workspacesHost, this.version, '/tokens/web-assistant');
		return await api.send('POST', url);
	}
}


export const workspacesApi = new WorkspacesApi();
